module.exports = __webpack_public_path__ + "static/ceramic09-2d8e8a2f533a6faabd9c029d1ee29a3f.jpg";